import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import Layout from '@/layouts/Default'
import GlobalNavigation from '@/components/GlobalNavigation'
import GlobalFooter from '@/components/GlobalFooter'
import VueLink from 'vue-link'
import VueScrollTo from 'vue-scrollto'
import ga from 'vue-ga'
import 'focus-visible'
import 'whatwg-fetch'

Vue.use(VueMeta)
Vue.use(VueScrollTo)

// Global Components
Vue.component('layout', Layout)
Vue.component('global-navigation', GlobalNavigation)
Vue.component('global-footer', GlobalFooter)
Vue.component('vue-link', VueLink)

ga(router, 'UA-35555329-25')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
